import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext({
  user: null,
  loading: true,
  signInWithGoogle: async () => {},
  signInDemo: async () => {},
  signOut: () => {},
  refresh: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("savebox_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("savebox_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const signInWithGoogle = useCallback(async () => {
    const { data } = await api.get("/auth/google/login?intent=login");
    window.location.href = data.authorization_url;
  }, []);

  const signInWithMicrosoft = useCallback(async () => {
    const { data } = await api.get("/auth/microsoft/login?intent=login");
    window.location.href = data.authorization_url;
  }, []);

  const signInDemo = useCallback(async () => {
    const { data } = await api.post("/auth/demo-login");
    localStorage.setItem("savebox_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem("savebox_token");
    setUser(null);
    window.location.href = "/";
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, signInWithGoogle, signInWithMicrosoft, signInDemo, signOut, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
